// Desktop release artifacts live in the public, source-free
// Anyrainel/mavori-desktop repo (apps/desktop/README.md "Releasing"). Every
// artifactName there is version-free, so `releases/latest/download/<file>`
// is a stable link that never needs to know the current version.
const RELEASES_BASE = "https://github.com/Anyrainel/mavori-desktop/releases/latest/download";

export type DesktopPlatform = "windows" | "mac-arm64" | "linux";

export const DESKTOP_DOWNLOADS: Record<DesktopPlatform, string> = {
  windows: `${RELEASES_BASE}/Mavori_Installer_Windows_x64.exe`,
  "mac-arm64": `${RELEASES_BASE}/Mavori_Installer_macOS_arm64.dmg`,
  linux: `${RELEASES_BASE}/Mavori_Linux_x64.AppImage`,
};

/**
 * Store listing link, e.g. `https://apps.microsoft.com/detail/<StoreID>`.
 * Empty until the app is submitted through Partner Center — see
 * apps/desktop/README.md "Windows distribution: direct download vs.
 * Microsoft Store". The download page hides the Store button while this is
 * empty rather than ship a dead link.
 */
export const WINDOWS_STORE_URL = "";
